import type { FC } from 'react';
import { ConcurrentCollectionWrapper } from './ConcurrentCollection.styled';

interface ConcurrentCollectionProps { }

const ConcurrentCollection: FC<ConcurrentCollectionProps> = () => (
   <ConcurrentCollectionWrapper>
      <header className="entry-header ">
         <h1 className="entry-title" itemProp="headline">Concurrent Collection</h1>
      </header>
      <br/>
      <div className="entry-content clear" itemProp="text">
         <p className="text-align-justify">
            java.util.concurrent package contains some additions to the Java Collections Framework. They are known as Java Concurrent Collections.
            Concurrent Collections only consist of synchronized classes. Therefore we don’t have to take care of Thread-safety.
            <br />In the Traditional Collections, if a thread is iterating a Collection object and if another thread tries to add a new element in that iterating object simultaneously then we will get ConcurrentModificationException. However, we won’t get any Runtime Exception if we are Working with Concurrent Collections Classes.
         </p>
         <br/>
         <h5 className="text-align-justify"><strong>Following are the concurrent collection classes :</strong></h5>
         <br/>
         <h4 className="text-align-justify"><strong>BlockingQueue </strong></h4>
         <ul className="text-align-justify">
            <li>It is a first-in-first-out data structure.</li>
            <li>The blocking queue blocks or times out when you attempt to add to a full queue or retrieve it from an empty queue.</li>
            <li>While adding an element, if there is no space it can wait till it becomes available.</li>
            <li>When retrieving an element, it will wait until an element is available if it is empty.</li>
            <li>Types of blocking queue :
               <ul>
                  <li><strong>ArrayBlockingQueue :</strong> It is a blocking queue class based on bounded Java Array. Once it’s instantiated, it cannot be resized.</li>
                  <li><strong>SynchronousQueue :</strong> It is a blocking queue class with a capacity of zero always.</li>
                  <li><strong>PriorityBlockingQueue :</strong> It is a priority queue based blocking queue. It is an unbounded concurrent collection.</li>
                  <li><strong>LinkedBlockingQueue :</strong> It is an optionally bounded concurrent collection. In addition, it orders elements based on the FIFO order.</li>
               </ul>
            </li>
         </ul>
         <br/>

         <h4 className="text-align-justify"><strong>DelayQueue </strong></h4>
         <ul className="text-align-justify">
            <li>It is a queue where the only delay expired elements can be taken out. In addition, its an unbounded concurrent collection.</li>
         </ul>
         <br/>

         <h4 className="text-align-justify"><strong>BlockingDeque </strong></h4>
         <ul className="text-align-justify">
            <li>It is an interface that extends BlockingQueue and adds the operations of Deque. </li>
            <li><strong>LinkedBlockingDeque</strong> is an implementation class of BlockingDequeue.</li>
         </ul>
         <br/>

         <h4 className="text-align-justify"><strong>TransferQueue </strong></h4>
         <ul className="text-align-justify">
            <li>It is a concurrent collection interface.</li>
            <li>It extends the BlockingQueue.</li>
            <li>In addition, it adds a method where the producer will wait for the consumer to receive elements. </li>
            <li><strong>LinkedTransferQueue</strong> is an implementation class of TransferQueue.</li>
         </ul>
         <br/>

         <h4 className="text-align-justify"><strong>ConcurrentMap </strong></h4>
         <ul className="text-align-justify">
            <li>ConcurrentMap is a Java concurrent collection interface and a type of Map.</li>
            <li>Above all, it guarantees thread safety and atomicity.</li>
            <br/>
            <li>Types of a concurrent map :
               <ul>
                  <li><strong>ConcurrentHashMap :</strong>
                     <ul>
                        <li>ConcurrentHashMap is an implementation class of ConcurrentMap.</li>
                        <li>It allows concurrent writer and reader threads. In other words, it allows one thread to modify the map &amp; the other thread to read values from the map at the same time.</li>
                        <li>It has following atomic operations like
                           <ul>
                              <li>putIfAbsent(key, value)</li>
                              <li>remove(key, value)</li>
                              <li>replace(key, value)</li>
                              <li>replace(key, oldValue, newValue)</li>
                           </ul>
                        </li>
                     </ul>
                  </li>
                  <br/>
                  <li><strong>ConcurrentNavigableMap :</strong> It is a Java concurrent collection interface that extends ConcurrentMap and adds operations of NavigableMap.</li>
                  <br/>
                  <li><strong>ConcurrentSkipListMap :</strong> It is an implementation class of ConcurrentNavigableMap.</li>
               </ul>
            </li>
         </ul>
      </div>
   </ConcurrentCollectionWrapper>
);

export default ConcurrentCollection;
